import { QBOIntegration } from './QBOIntegration';

export default QBOIntegration;
